exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VueCarousel-dot .VueCarousel-dot-inner {\n  background: var(--testimonialBullet-color) !important;\n}\n.VueCarousel-dot.VueCarousel-dot--active .VueCarousel-dot-inner {\n  background: var(--testimonialBulletActive-color) !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cca75d2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/portal/homeData/HomeBlock.vue
// module id = 332
// module chunks = 4